import {api} from './api';
import {SWAP_TOKEN_URL_PATH} from '../constants';
import { Currencies } from '../types';

export interface MyCompany {
	id: number;
	profileId: string | null;
	name: string;
	bio: string;
	imgUrl: string | null
	coverImgUrl: string | null;
	roleCustomer: boolean;
	roleCreator: boolean;
	roleVendor: boolean;
}

export interface CompanyVendorProfile {
	id: number;
	name: string;
	description: string;
	address: string;
	legalName: string;
	taxId: string;
	receiveOrdersEmail: string;
	website: string;
	imgUrl: string;
	vendorContactEmail: string;
	currency: Currencies;
}

export interface MyAccount {
	id: number;
	companyId: number;
	email: string;
	firstName: string;
	lastName: string;
	name: string;
	isEmailVerified: boolean;
}

export interface MyAccountResponse extends MyAccount {
	company: MyCompany;
}

interface SwapTokenRequest {
	auth0Token: string;
}

interface SwapTokenResponse {
	token: string;
}

export const accountsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		swapToken: builder.mutation<SwapTokenResponse, SwapTokenRequest>({
			query: ({ auth0Token }) => ({
				url: SWAP_TOKEN_URL_PATH,
				method: 'POST',
				body: {
					auth0Token,
				},
			}),
			extraOptions: { maxRetries: 1 }
		}),
		swapTokenFake: builder.mutation<SwapTokenResponse, SwapTokenRequest>({
			query: ({ auth0Token }) => ({
				url: SWAP_TOKEN_URL_PATH,
				method: 'POST',
				body: {
					auth0Token,
				},
			}),
			extraOptions: { maxRetries: 1 }
		}),
		getMyAccount: builder.mutation<MyAccountResponse, void>({
			query: () => ({
				url: 'accounts/myAccount',
				method: 'GET',
			}),
			extraOptions: { maxRetries: 1 }
		}),
		updateMyAccount: builder.mutation<Partial<MyAccount>, Partial<MyAccount>>({
			query: (data) => ({
				url: 'accounts/myAccount',
				method: 'PUT',
				body: data,
			}),
			extraOptions: { maxRetries: 1 }
		}),
		updateMyCompany: builder.mutation<Partial<MyCompany>, Partial<MyCompany>>({
			query: (data) => ({
				url: 'company/myCompany',
				method: 'PUT',
				body: data,
			}),
			extraOptions: { maxRetries: 1 }
		}),
		activateCreatorProfile: builder.mutation<{ id: number }, {profileId: string, region: string, name: string}>({
			query: (data) => ({
				url: 'company/activateCreatorProfile',
				method: 'POST',
				body: data,
			}),
			extraOptions: { maxRetries: 1 }
		}),
	}),
});

export const { useSwapTokenMutation, useGetMyAccountMutation, useUpdateMyCompanyMutation, useUpdateMyAccountMutation, useActivateCreatorProfileMutation } = accountsApi;
